// extracted by mini-css-extract-plugin
export default {"menuList":"RSmN6A","menuItem":"SdXNSs","menuItemLink":"HfFYfX","newItemUi":"PYkcgW","searchFadeIn":"YjH1ZH"};